export default function digits(value: number, digits: number): number {
  const scale = value.toString().split(".")[0].length;
  const scalar = Math.pow(10, scale - digits);
  return Math.round(value / scalar) * scalar;
}
